@if (product.data?.specification_section) {
  <div class="flex flex-justify-center flex-wrap m-r-4-m m-r-4-s"
    [scrollNavTarget]="'Specs' | translate">
    @for (sectionId of sections ; track $index; let isLast = $last) {
      <div
        class="w-3 w-6-m w-6-s p-a p-b-0"
        [ngClass]="(client.isX || client.isL) ? isLast ? 'p-r' : 'p-r-0' : 'p-r-0'">
        <cms-specification-section-item class="block"
        [variant]="'specification-section' + sectionId"></cms-specification-section-item>
      </div>
    }
  </div>
  <div class="flex flex-justify-center flex-wrap">
    <div class="w-12 flex flex-justify-center">
      <action class="button m-t"
        [status]="modalStatus"
      (click)=openModal()>{{'Learn more' | translate}}</action>
    </div>
  </div>
}